import type { ReactNode } from 'react';

interface PageSectionHeadProps {
  title: ReactNode;
  sub?: ReactNode;
}

/**
 * PageSectionHead — canonical page-level title block used at the top
 * of inner routes (settings, admin, etc.). Geist 16/500 title plus an
 * optional secondary sub line; no variants or className overrides.
 */
export function PageSectionHead({ title, sub }: Readonly<PageSectionHeadProps>): React.JSX.Element {
  return (
    <header className="mb-6 flex flex-col gap-1">
      <h1 className="m-0 text-section-title font-medium leading-tight text-foreground">{title}</h1>
      {sub ? (
        <p className="m-0 max-w-prose-2xl text-meta leading-relaxed text-muted-foreground">{sub}</p>
      ) : null}
    </header>
  );
}
